// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"D_0xszw5SckWpAK4chyiV","spaceLeft":"_3ZPF7CO3WliRhAJGGsVzud","spaceBoth":"fU9v-YZ7CvcV0nqeIDQll","spaceRight":"_26pdOE99mLdZcs0aLGuZxm","StatusIndicator--Online":"BI1FCsrxoamKj8eLgbGuI","StatusIndicator--Out-Of-Sync":"_1gsebS5RABVyuQfk50jKq2","StatusIndicator--Closed":"_1NtuTYGajOCuo9S28rJYVq","StatusIndicator":"_50LOZxa2zd7uz5X_s1twD","OasisStatus":"_3pD6VZQp3sW3I7WWfnV8d2","NetworkStatus":"_2LWI-PT9WwVQsfLq70hmAP","offersLoadProgress":"_3qcfnJz9hyANRRN4rD-V8S","tradesLoadProgress":"_26LETdlTGTWpuxEpad4jm-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisStatus.scss
// module id = 1065
// module chunks = 0